import { render, staticRenderFns } from "./ControlsForm.vue?vue&type=template&id=5b130a5d&"
import script from "./ControlsForm.vue?vue&type=script&lang=js&"
export * from "./ControlsForm.vue?vue&type=script&lang=js&"
import style0 from "./ControlsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports